import React from "react";

export const AppDataContext = React.createContext();
